window.setSpinner = function(){
  return("<div class='w-100 d-flex justify-content-center mt-2'><div class='spinner-border spinner-border-sm text-primary'></div></div>")
}

window.dtSingleDateFilter = function(){
  return(`
    <div class="d-flex align-items-center gap-1 me-2">
      <input type="date" id="dt-filter-single-date" class="form-control form-control-sm" value="${todayYMD()}">
    </div>
  `)
}

window.dtNewReservationLookUp = function(){
  return(`
    <button class="btn btn-sm btn-primary text-nowrap me-2" id="new-reservation-lookup">
      List Reservasi Baru
    </button>
  `)
}

window.dtDoubleDateFilter = function(){
  return(`
    <div class="d-flex align-items-center gap-1 me-2">
      <input type="date" class="form-control form-control-sm" value="${todayYMD()}">
      -
      <input type="date" class="form-control form-control-sm" value="${todayYMD()}">
    </div>
  `)
}